import './EnvBanner.scss'

/**
 * The portal's rule (CustomAppBar.tsx:7-12): shown when the env is
 * `development` (any case) or the hostname starts with `develop`.
 */
export function shouldShowEnvBanner(env: string | undefined, hostname: string): boolean {
  return env?.toLowerCase() === 'development' || hostname.startsWith('develop')
}

export interface EnvBannerProps {
  version: string
  /** Defaults to `APP_ENV`. */
  env?: string | undefined
  /** Defaults to `location.hostname`. */
  hostname?: string
}

/** "DEVELOPMENT - v{version}" in the top bar on development builds and hosts. */
export function EnvBanner({
  version,
  env = import.meta.env.APP_ENV,
  hostname = window.location.hostname
}: EnvBannerProps) {
  if (!shouldShowEnvBanner(env, hostname)) return null
  // Narrow screens show "DEV"; the full text stays the accessible name.
  return (
    <p className="env-banner" aria-label={`DEVELOPMENT - v${version}`}>
      <span className="env-banner__full" aria-hidden="true">
        DEVELOPMENT - v{version}
      </span>
      <span className="env-banner__short" aria-hidden="true">
        DEV
      </span>
    </p>
  )
}
